import { render, staticRenderFns } from "./BtApps.vue?vue&type=template&id=21645bc1&scoped=true&"
import script from "./BtApps.vue?vue&type=script&lang=js&"
export * from "./BtApps.vue?vue&type=script&lang=js&"
import style0 from "./BtApps.vue?vue&type=style&index=0&id=21645bc1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21645bc1",
  null
  
)

export default component.exports